const clamp = (value, min, max) => Math.max(min, Math.min(max, value));

export function clampView(view, geometry) {
  const { width, height, imageWidth, imageHeight, fitScale } = geometry;
  const scaledWidth = imageWidth * fitScale * view.zoom, scaledHeight = imageHeight * fitScale * view.zoom;
  // Keep a visible part of the image while allowing off-centre crops to be centred too.
  const maxX = Math.max(0, (scaledWidth + width) / 2 - Math.min(64, scaledWidth / 2, width / 2));
  const maxY = Math.max(0, (scaledHeight + height) / 2 - Math.min(64, scaledHeight / 2, height / 2));
  return { ...view, x: clamp(view.x, -maxX, maxX) || 0, y: clamp(view.y, -maxY, maxY) || 0 };
}

// point is measured from the viewport centre. Keep that exact image point under the cursor.
export function zoomViewAt(view, requestedZoom, point, geometry) {
  const zoom = clamp(requestedZoom, 0.2, Math.max(5, 4 / (geometry.fitScale || 1)));
  const ratio = zoom / view.zoom;
  return clampView({ zoom, x: point.x - (point.x - view.x) * ratio, y: point.y - (point.y - view.y) * ratio }, geometry);
}

export function fitRegions(regions, geometry) {
  if (!regions.length || !geometry.fitScale) return { zoom: 1, x: 0, y: 0 };
  const minX = Math.min(...regions.map(region => Math.min(region.x1, region.x2)));
  const maxX = Math.max(...regions.map(region => Math.max(region.x1, region.x2)));
  const minY = Math.min(...regions.map(region => Math.min(region.y1, region.y2)));
  const maxY = Math.max(...regions.map(region => Math.max(region.y1, region.y2)));
  if (maxX <= minX || maxY <= minY) return { zoom: 1, x: 0, y: 0 };
  const scale = Math.min((geometry.width - 32) / (maxX - minX), (geometry.height - 32) / (maxY - minY));
  const zoom = clamp(scale / geometry.fitScale, 0.2, Math.max(5, 4 / geometry.fitScale));
  const actualScale = geometry.fitScale * zoom;
  return clampView({ zoom,
    x: (geometry.imageWidth / 2 - (minX + maxX) / 2) * actualScale,
    y: (geometry.imageHeight / 2 - (minY + maxY) / 2) * actualScale,
  }, geometry);
}
